<div
  class="m-auto grid grid-flow-row gap-3 justify-center box-border py-5 px-9 bg-neutrals-100 relative w-[1243px] max-w-[1243px]"
>
  <div
    class="flex justify-end items-center min-w-[600px] w-[1100px] max-w-[1100px] mb-[12px]"
  >
    <button (click)="closeModal()" type="button">
      <ui-icon name="close" fill="neutrals-600" m-size="24" size="24" />
    </button>
  </div>
  <div *ngIf="showCommercialAgreement; else agreementLoading">
    <div
      class="py-[40px] px-[128px] bg-neutrals-300 border-neutrals-300 border-[1px] rounded-lg"
    >
      <div class="flex flex-col">
        <ui-paragraph
          type="p18"
          mobile-type="p18"
          text-color="neutrals-900"
          font-weight="semibold"
        >
          Acuerdo de venta
        </ui-paragraph>
      </div>

      <form
        [formGroup]="form"
        class="mt-[40px] bg-neutrals-0 py-5 px-6 rounded-xl border-[1px]"
        [ngClass]="{
          'border-neutrals-300 ': !editForm,
          'border-unicon-yellow-100': editForm,
        }"
      >
        <div class="flex justify-between">
          <ui-paragraph
            type="p16"
            mobile-type="p16"
            text-color="neutrals-900"
            font-weight="semibold"
          >
            Resumen general
          </ui-paragraph>
          <button
            (click)="onEditCommercialAgreement()"
            class="cursor-pointer"
            *ngIf="!editForm"
            type="button"
          >
            <ui-icon name="edit" fill="neutrals-600" m-size="16" size="16" />
          </button>

          <button
            (click)="onSaveEdit()"
            class="w-[70px] h-[30px] cursor-pointer bg-unicon-yellow-100 px-2 rounded-[6px] flex items-center justify-center"
            *ngIf="editForm"
            type="button"
          >
            <ui-paragraph
              *ngIf="!isLoadingSaveEdit"
              type="p12"
              mobile-type="p12"
              text-color="neutrals-900"
              font-weight="regular"
            >
              Guardar
            </ui-paragraph>
            <ui-loader *ngIf="isLoadingSaveEdit" type="secondary" size="xl" />
          </button>
        </div>
        <div *ngIf="showMessageError">
          <ui-paragraph
            type="p12"
            mobile-type="p12"
            text-color="critical-300"
            font-weight="regular"
          >
            Selecciona una fecha y hora disponible para continuar
          </ui-paragraph>
        </div>
        <div class="grid grid-cols-6 gap-3 mt-3">
          <div
            class="col-span-1 unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px] border-neutrals-100"
            [ngClass]="{
              'border-unicon-yellow-100': !form.get('leadName')?.value,
            }"
            #leadNameBox
          >
            <ui-icon name="user" size="16" mSize="16" fill="neutrals-600" />
            <input
              type="text"
              placeholder="Nombre de cliente"
              formControlName="leadName"
              (focus)="leadNameBox.classList.toggle('border-neutrals-900')"
              (blur)="leadNameBox.classList.toggle('border-neutrals-900')"
            />
          </div>
          <div
            class="col-span-1 unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px] border-neutrals-100"
            [ngClass]="{
              'border-unicon-yellow-100': !form.get('paternalSurname')?.value,
            }"
            #paternalSurnameBox
          >
            <ui-icon name="user" size="16" mSize="16" fill="neutrals-600" />
            <input
              type="text"
              placeholder="Apellido Paterno"
              formControlName="paternalSurname"
              (focus)="
                paternalSurnameBox.classList.toggle('border-neutrals-900')
              "
              (blur)="
                paternalSurnameBox.classList.toggle('border-neutrals-900')
              "
            />
          </div>
          <div
            class="col-span-1 unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px] border-neutrals-100"
            [ngClass]="{
              'border-unicon-yellow-100': !form.get('maternalSurname')?.value,
            }"
            #maternalSurnameBox
          >
            <ui-icon name="user" size="16" mSize="16" fill="neutrals-600" />
            <input
              type="text"
              placeholder="Apellido Materno"
              formControlName="maternalSurname"
              (focus)="
                maternalSurnameBox.classList.toggle('border-neutrals-900')
              "
              (blur)="
                maternalSurnameBox.classList.toggle('border-neutrals-900')
              "
            />
          </div>
          <div
            class="col-span-1 unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px] border-neutrals-100"
            [ngClass]="{
              'border-unicon-yellow-100': !form.get('document')?.value,
            }"
            #documentBox
          >
            <ui-icon name="id" size="16" mSize="16" fill="neutrals-600" />
            <input
              type="text"
              placeholder="Número de documento"
              formControlName="document"
              maxlength="12"
              (focus)="documentBox.classList.toggle('border-neutrals-900')"
              (blur)="documentBox.classList.toggle('border-neutrals-900')"
            />
          </div>
          <div class="col-span-2">
            <mat-slide-toggle
              [checked]="receptionContact"
              [disabled]="disabled"
              (change)="onTogglReceptionContact($event.checked)"
            >
              Mismos datos para el contacto de recepción
            </mat-slide-toggle>
          </div>
        </div>

        <div *ngIf="!receptionContact" class="grid grid-cols-2 gap-3 mt-3">
          <div
            class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px] border-neutrals-100"
            [ngClass]="{
              '!border-unicon-yellow-100': !form.get('receptionContactName')
                ?.value,
            }"
            #receptionContactNameBox
          >
            <ui-icon name="user" size="16" mSize="16" fill="neutrals-600" />
            <input
              type="text"
              placeholder="Contacto de recepción"
              formControlName="receptionContactName"
              (focus)="
                receptionContactNameBox.classList.toggle('border-neutrals-900')
              "
              (blur)="
                receptionContactNameBox.classList.toggle('border-neutrals-900')
              "
            />
          </div>

          <div
            class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px] border-neutrals-100"
            [ngClass]="{
              'border-unicon-yellow-100': !form.get('phoneNumber')?.value,
            }"
            #phoneNumberBox
          >
            <ui-icon name="phone" size="16" mSize="16" fill="neutrals-600" />
            <input
              type="text"
              placeholder="N° de celular"
              formControlName="phoneNumber"
              maxlength="12"
              (focus)="phoneNumberBox.classList.toggle('border-neutrals-900')"
              (blur)="phoneNumberBox.classList.toggle('border-neutrals-900')"
              uniconPhoneFormatter
            />
          </div>
        </div>

        <div class="mt-3">
          <div
            class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px] border-neutrals-100"
            [ngClass]="{
              'border-unicon-yellow-100': !form.get('email')?.value,
            }"
            #emailBox
          >
            <ui-icon name="message" size="16" mSize="16" fill="neutrals-600" />
            <input
              type="text"
              placeholder="Correo Electronico"
              formControlName="email"
              (focus)="emailBox.classList.toggle('border-neutrals-900')"
              (blur)="emailBox.classList.toggle('border-neutrals-900')"
            />
          </div>
        </div>
        <div class="grid grid-cols-3 gap-3 mt-3">
          <div class="col-span-2">
            <div
              class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px] border-neutrals-100"
              [ngClass]="{
                'border-unicon-yellow-100': !form.get('address')?.value,
              }"
              #addressBox
            >
              <ui-icon name="gps" size="16" mSize="16" fill="neutrals-600" />
              <input
                type="text"
                placeholder="Direccion"
                formControlName="address"
                (focus)="addressBox.classList.toggle('border-neutrals-900')"
                (blur)="addressBox.classList.toggle('border-neutrals-900')"
              />
            </div>
          </div>
          <mat-slide-toggle
            [checked]="fiscalAddress"
            [disabled]="disabled"
            (change)="onToggleFiscalAddress($event.checked)"
          >
            Declaro esta mi dirección fiscal
          </mat-slide-toggle>
        </div>
        <div *ngIf="!fiscalAddress" class="grid grid-cols-1 gap-3 mt-[46px]">
          <ui-paragraph
            type="p12"
            mobile-type="p12"
            text-color="neutrals-600"
            font-weight="regular"
          >
            Dirección fiscal
          </ui-paragraph>
          <div class="grid grid-cols-3 gap-3 mt-3">
            <div
              class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px] border-neutrals-100"
              [ngClass]="{
                'border-unicon-yellow-100': !form.get('department')?.value,
              }"
              #departmentBox
            >
              <ui-icon name="gps" size="16" mSize="16" fill="neutrals-600" />
              <input
                type="text"
                placeholder="Departamento"
                formControlName="department"
                (focus)="departmentBox.classList.toggle('border-neutrals-900')"
                (blur)="departmentBox.classList.toggle('border-neutrals-900')"
              />
            </div>
            <div
              class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px] border-neutrals-100"
              [ngClass]="{
                'border-unicon-yellow-100': !form.get('province')?.value,
              }"
              #provinceBox
            >
              <ui-icon name="gps" size="16" mSize="16" fill="neutrals-600" />
              <input
                type="text"
                placeholder="Provincia"
                formControlName="province"
                (focus)="provinceBox.classList.toggle('border-neutrals-900')"
                (blur)="provinceBox.classList.toggle('border-neutrals-900')"
              />
            </div>
            <div
              class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px] border-neutrals-100"
              [ngClass]="{
                'border-unicon-yellow-100': !form.get('district')?.value,
              }"
              #districtBox
            >
              <ui-icon name="gps" size="16" mSize="16" fill="neutrals-600" />
              <input
                type="text"
                placeholder="Distrito"
                formControlName="district"
                (focus)="districtBox.classList.toggle('border-neutrals-900')"
                (blur)="districtBox.classList.toggle('border-neutrals-900')"
              />
            </div>
          </div>
          <div class="grid grid-cols-2 gap-3 mt-3">
            <div
              class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px] border-neutrals-100"
              #streetTypeBox
            >
              <ui-icon name="gps" size="16" mSize="16" fill="neutrals-600" />
              <select
                formControlName="streetType"
                placeholder="Tipo de calle"
                (focus)="streetTypeBox.classList.add('focussed')"
                (blur)="streetTypeBox.classList.remove('focussed')"
                (change)="onSelectStreetTypeBox($event)"
              >
                <option value="" disabled selected hidden>
                  Seleccionar un tipo de calle
                </option>
                <option
                  *ngFor="let streetType of streetTypes"
                  [value]="streetType.id"
                >
                  {{ streetType.name }}
                </option>
              </select>
            </div>
            <div
              class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px] border-neutrals-100"
              [ngClass]="{
                'border-unicon-yellow-100':
                  !form.get('fiscalAddressName')?.value,
              }"
              #fiscalAddressNameBox
            >
              <ui-icon name="gps" size="16" mSize="16" fill="neutrals-600" />
              <input
                type="text"
                placeholder="Dirección"
                formControlName="fiscalAddressName"
                (focus)="
                  fiscalAddressNameBox.classList.toggle('border-neutrals-900')
                "
                (blur)="
                  fiscalAddressNameBox.classList.toggle('border-neutrals-900')
                "
              />
            </div>
          </div>
        </div>
        <div
          class="grid grid-cols-2 gap-3 mt-[49px]"
          *ngFor="let product of productList"
        >
          <div
            class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px] border-neutrals-100"
            #productBox
          >
            <ui-icon
              name="shopping-cart"
              size="16"
              mSize="16"
              fill="neutrals-600"
            />
            <input
              type="text"
              placeholder="Producto"
              value="{{ product.productVariantName }}"
              disabled="true"
            />
          </div>

          <div
            class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px] border-neutrals-100"
            #quantityBox
          >
            <ui-icon
              name="shopping-cart"
              size="16"
              mSize="16"
              fill="neutrals-600"
            />
            <input
              type="text"
              placeholder="Cantidad"
              value="{{ product.quantity + ' ' + product.measurementUnitName }}"
              disabled="true"
            />
          </div>
        </div>
        <div class="mt-3">
          <div
            class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px] border-neutrals-100"
            #totalBox
          >
            <ui-icon
              name="successfull-payment"
              size="16"
              mSize="16"
              fill="neutrals-600"
            />
            <input
              type="text"
              placeholder="Total"
              formControlName="total"
              (focus)="totalBox.classList.toggle('border-neutrals-900')"
              (blur)="totalBox.classList.toggle('border-neutrals-900')"
            />
          </div>
        </div>
      </form>
    </div>

    <div class="flex items-center justify-center mt-4 mb-6">
      <button
        type="submit"
        class="bg-unicon-yellow-100 border-unicon-yellow-100 text-[#0B2C56] w-[277px] flex flex-row justify-center items-center gap-2 btn-action rounded-[6px] py-2 px-4 box-border disabled:text-[#a9bcd9] disabled:!bg-[#D2DEF1] disabled:!cursor-not-allowed disabled:!border-[#D2DEF1]"
        [disabled]="!isFormValid()"
        (click)="onCreateAgreement()"
      >
        <div *ngIf="!isLoadingCreateAgreement" class="flex">
          <ui-paragraph
            type="p12"
            mobile-type="p12"
            font-weight="semibold"
            [textColor]="isFormValid() ? 'neutrals-900' : 'neutrals-600'"
          >
            Crear acuerdo de venta
          </ui-paragraph>
          <ui-icon
            name="arrow-right"
            [fill]="true ? 'neutrals-600' : 'neutrals-900'"
            m-size="20"
            size="20"
          />
        </div>

        <div *ngIf="isLoadingCreateAgreement">
          <ui-loader type="secondary" size="xl" />
        </div>
      </button>
    </div>
  </div>
  <div
    class="box-border absolute top-0 left-0 w-full h-full"
    *ngIf="showCalendarGridModal"
  >
    <unicon-datetime-grid-dialog
      class="quote-absolute-box"
      [orderId]="calendarOrderId"
      [date]="dateCalendarGrid"
      [firstResult]="calendarGridResult"
      (close)="onCloseCalendarGrid($event)"
    />
  </div>

  <ng-template #agreementLoading>
    <div
      class="py-[40px] px-[128px] bg-neutrals-300 border-neutrals-300 border-[1px] rounded-lg"
    >
      <div class="flex flex-col">
        <div class="w-[70px] h-[17px] mb-3">
          <ngx-skeleton-loader
            count="1"
            appearance="line"
            [theme]="{ marginBottom: '0px' }"
          />
        </div>
        <div class="w-[300px] h-[38px]">
          <ngx-skeleton-loader
            count="1"
            appearance="line"
            [theme]="{ marginBottom: '0px' }"
          />
        </div>
      </div>

      <div
        class="mt-[40px] bg-neutrals-0 py-5 px-6 rounded-xl border-neutrals-300 border-[1px]"
      >
        <div class="flex justify-between">
          <div class="w-[150px] h-[20px]">
            <ngx-skeleton-loader
              count="1"
              appearance="line"
              [theme]="{ marginBottom: '0px' }"
            />
          </div>
        </div>
        <div class="grid grid-cols-2 gap-3 mt-6">
          <div class="w-full h-[33px]">
            <ngx-skeleton-loader
              count="1"
              appearance="line"
              [theme]="{ marginBottom: '0px' }"
            />
          </div>
          <div class="w-full h-[33px]">
            <ngx-skeleton-loader
              count="1"
              appearance="line"
              [theme]="{ marginBottom: '0px' }"
            />
          </div>
        </div>
        <div class="grid grid-cols-3 gap-3 mt-3">
          <div class="w-full h-[33px]">
            <ngx-skeleton-loader
              count="1"
              appearance="line"
              [theme]="{ marginBottom: '0px' }"
            />
          </div>
          <div class="w-full h-[33px]">
            <ngx-skeleton-loader
              count="1"
              appearance="line"
              [theme]="{ marginBottom: '0px' }"
            />
          </div>
          <div class="w-full h-[33px]">
            <ngx-skeleton-loader
              count="1"
              appearance="line"
              [theme]="{ marginBottom: '0px' }"
            />
          </div>
        </div>
        <div class="mt-3">
          <div class="w-full h-[33px]">
            <ngx-skeleton-loader
              count="1"
              appearance="line"
              [theme]="{ marginBottom: '0px' }"
            />
          </div>
        </div>
        <div class="grid grid-cols-3 gap-3 mt-3">
          <div class="col-span-2">
            <div class="w-full h-[33px]">
              <ngx-skeleton-loader
                count="1"
                appearance="line"
                [theme]="{ marginBottom: '0px' }"
              />
            </div>
          </div>

          <div class="w-full h-[33px]">
            <ngx-skeleton-loader
              count="1"
              appearance="line"
              [theme]="{ marginBottom: '0px' }"
            />
          </div>
        </div>
        <div class="grid grid-cols-2 gap-3 mt-3">
          <div class="w-full h-[33px]">
            <ngx-skeleton-loader
              count="1"
              appearance="line"
              [theme]="{ marginBottom: '0px' }"
            />
          </div>

          <div class="w-full h-[33px]">
            <ngx-skeleton-loader
              count="1"
              appearance="line"
              [theme]="{ marginBottom: '0px' }"
            />
          </div>
        </div>
        <div class="grid grid-cols-2 gap-3 mt-3">
          <div class="w-full h-[33px]">
            <ngx-skeleton-loader
              count="1"
              appearance="line"
              [theme]="{ marginBottom: '0px' }"
            />
          </div>

          <div class="w-full h-[33px]">
            <ngx-skeleton-loader
              count="1"
              appearance="line"
              [theme]="{ marginBottom: '0px' }"
            />
          </div>
        </div>
        <div class="mt-3">
          <div class="w-full h-[33px]">
            <ngx-skeleton-loader
              count="1"
              appearance="line"
              [theme]="{ marginBottom: '0px' }"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="flex items-center justify-center mb-6">
      <div class="flex justify-between">
        <div class="w-[277px] h-[28px]">
          <ngx-skeleton-loader
            count="1"
            appearance="line"
            [theme]="{ marginBottom: '0px' }"
          />
        </div>
      </div>
    </div>
  </ng-template>
</div>
